<template>
    <div class="d-inline" v-if="!disableLogin">
        <div v-if="as_text" class="d-inline">
            <a @click="openLogin" href="javascript:void(0)">{{$t('auth.login')}}</a>
        </div>
        <div class="mr-3 mr-lg-0" v-else>
            <b-button variant="light" v-if="!logged" class="btn-circle p-0 mr-2" @click="openLogin">
                <a @click="openLogin" href="javascript:void(0)"><img src="../assets/svg/icon-auth-primary.svg" width="42" height="42" alt=""></a>
            </b-button>
            <b-dropdown size="lg" v-if="logged" right variant="link" toggle-class="text-decoration-none p-0" no-caret>
                <template v-slot:button-content>
                    <img src="../assets/svg/icon-auth-primary.svg" width="42" height="42" alt="">
                    <img src="../assets/svg/icon_arrow-down-dark.svg" height="10" class="ml-2">
                </template>
                <b-dropdown-item class="bg-white h6 font-weight-bold font-family-sans-serif m-0" style="background:white;">
                    {{user_name}} {{user_surname}}
                </b-dropdown-item>
                <b-dropdown-item class="small text-danger bg-white" @click="openEdit" style="background:white;">
                    <span class="text-secondary">{{$t('auth.edit')}}</span><img src="../assets/svg/icon-edit.svg" height="16" class="ml-2">
                </b-dropdown-item>
                <b-dropdown-item class="small text-danger bg-white mt-3" @click="logout">
                    <span class="text-danger">{{$t('auth.logout')}}</span><img src="../assets/svg/icon-logout.svg" height="20" class="ml-2">
                </b-dropdown-item>
            </b-dropdown>
        </div>


        <b-modal id="mod_login" :title="reg_title" ref="mod_login" @ok="doAction" @show="getRegisterData" :hide-footer="in_login || in_recovery">
            <div v-if="in_login">
                <b-form @submit="login">
                    <div class="text-orange small mt-3 ml-3 mb-2"><span class="d-block text-orange font-weight-bold"><b>{{$t('auth.title_login_enternow')}}</b></span></div>
                    <div class="text-orange small mt-1 ml-3 mb-1"><span class="bg-light py-2 px-3 rounded d-inline-block">{{$t('auth.message_login_enternow')}}</span></div>                    
                    <label class="font-weight-bold">{{$t('auth.email_address')}}</label>
                    <b-form-input v-model="email" :placeholder="$t('auth.email_address')" size="lg"  id="login_email"></b-form-input>
                    <label class="font-weight-bold">{{$t('auth.password')}}</label>
                    <b-form-input v-model="password" type="password" size="lg" :placeholder="$t('auth.password')"></b-form-input>
                    <div class="pt-4 pb-3">
                        <b-form-checkbox v-model="remember">{{$t('auth.remember')}}</b-form-checkbox>
                    </div>
                    <b-button class="mt-1 w-100 justify-content-center" variant="primary" size="lg" type="submit">{{$t('auth.login')}}</b-button>
                </b-form>
                <div class="signup-wrapper">
                    <div class="signup-wrapper--help-text">{{$t('auth.signup_helptext')}}</div>
                    <a class="signup-wrapper--btn" @click="openRegister">{{$t('auth.signup')}}</a>
                </div>
                <div class="text-center mt-3"><a @click="openRecover">{{$t('auth.forgot_password')}}</a></div>
            </div>
            <div v-if="in_recovery">
                <b-form @submit="recover">
                    <div class="text-orange small mt-1 ml-3 mb-1"><span class="bg-light py-2 px-3 rounded d-inline-block">{{$t('auth.message_login_enternow')}}</span></div>                    
                    <label>{{$t('auth.email_address')}}</label>
                    <b-form-input v-model="email" :placeholder="$t('auth.email_address')" size="lg"  id="login_email"></b-form-input>
                    <b-button class="mt-1 w-100" variant="primary" size="lg" type="submit">{{$t('auth.recover_password')}}</b-button>
                </b-form>
                <div class="mt-1 text-center"><a @click="openLogin">{{$t('auth.return_login')}}</a></div>
            </div>
            <b-form class="form-row" @submit="doRegister" v-if="in_register">
                <div class="col-md-12">
                    <label>{{$t('auth.email_address')}}</label>
                    <b-form-input v-model="register.email" v-validate="'required|email'" data-vv-name="email"
                                  :placeholder="$t('auth.email_address')"
                                  size="lg"
                    ></b-form-input>
                    <div v-show="errors.has('email')" class="error">{{ errors.first('email') }}</div>
                </div>
                <div class="col-md-12 mt-1">
                    <label>{{$t('auth.password')}}</label>
                    <b-form-input v-model="register.password" type="password" data-vv-name="password"
                                  v-validate="'required|min:3'" ref="password"
                                  :placeholder="$t('auth.password')"
                                  size="lg"
                    ></b-form-input>
                    <div v-show="errors.has('password')" class="error">{{ errors.first('password') }}</div>
                </div>
                <div class="col-md-12 mt-1">
                    <label>{{$t('auth.confirm_password')}}</label>
                    <b-form-input type="password" v-validate="'required|confirmed:password'"
                                  :placeholder="$t('auth.confirm_password')"
                                  v-model="register.repassword"
                                  size="lg"
                                  data-vv-name="password_confirm"></b-form-input>
                    <div v-show="errors.has('password_confirm')" class="error">{{ errors.first('password_confirm')
                        }}</div>
                </div>
                <div class="col-md-6 mt-4">
                    <label>{{$t('auth.first_name')}}</label>
                    <b-form-input v-model="register.name" v-validate="'required|min:2|max:16'" data-vv-name="name"
                                  :placeholder="$t('auth.first_name')"
                                  size="lg"
                    ></b-form-input>
                    <div v-show="errors.has('name')" class="error">{{ errors.first('name') }}</div>
                </div>
                <div class="col-md-6 mt-4">
                    <label>{{$t('auth.last_name')}}</label>
                    <b-form-input v-model="register.surname" v-validate="'required|min:2|max:16'" data-vv-name="surname"
                                  :placeholder="$t('auth.last_name')"
                                  size="lg"
                    ></b-form-input>
                    <div v-show="errors.has('surname')" class="error">{{ errors.first('surname') }}</div>
                </div>
                <div class="col-md-6 mt-1">
                    <label>{{$t('auth.date_of_birth')}}</label>
                    <b-input type="text"
                             v-model="register.birthdate"
                             data-vv-name="birthdate"
                             size="lg"
                             placeholder="gg-mm-aaaa"
                             autocomplete="nope"
                             v-validate="`required|date_format:dd-mm-yyyy|date_between:01-01-1900,${data_max}`"
                             data-vv-as="data di nascita"
                             key="data_nascita"
                             :formatter="data_format"
                             required></b-input>
                    <div v-show="errors.has('birthdate')" class="error">{{ errors.first('birthdate') }}</div>
                </div>
                <div class="col-md-6 mt-1">
                    <label>{{$t('auth.gender')}}</label>
                    <b-form-select size="lg" v-model="register.sex" v-validate="'required'" data-vv-name="sex"
                                   :options="$t('sesso')"></b-form-select>
                    <div v-show="errors.has('sex')" class="error">{{ errors.first('sex') }}</div>
                </div>
                <div class="col-md-12 mt-1">
                    <label>{{$t('auth.country')}}</label>
                    <b-form-select size="lg" v-model="register.country" :options="country"></b-form-select>
                </div>
                <div class="col-md-12 mt-1" v-if="register.country === 'ITA'">
                    <label>{{$t('auth.administrativeArea')}}</label>
                    <b-form-select size="lg" v-model="register.region" :options="region"></b-form-select>
                </div>
                <div class="col-md-12 mt-1 mb-3">
                    <label>{{$t('auth.choose_sport')}}</label>
                    <multiselect v-model="sel.disciplines"
                                 :options="disciplines"
                                 :multiple="true"
                                 track-by="value"
                                 label="text"
                    ></multiselect>
                </div>
                <div class="col-md-12 mt-1">
                    <b-form-checkbox v-model="register.check_uso_portale"  :value="true">
                        {{$t('auth.testo_uso_portale')}}
                    </b-form-checkbox>
                </div>
                <div class="col-md-12 mt-1">
                    <b-form-checkbox v-model="register.check_comunicazioni"  :value="true">
                        {{$t('auth.testo_comunicazioni')}}
                    </b-form-checkbox>
                </div>
                <div class="col-md-12 mt-1">
                    <b-form-checkbox v-model="register.check_terzi"  :value="true">
                        {{$t('auth.terzo_terzi')}}
                    </b-form-checkbox>
                </div>

            </b-form>
            <b-form class="form-row" @submit="doEdit" v-if="in_edit">
                <div class="col-md-12">
                    <label>{{$t('auth.email_address')}}</label>
                    <b-form-input v-model="edit.email" v-validate="'required|email'" data-vv-name="email"
                                  :placeholder="$t('auth.email_address')"
                                  size="lg"
                    ></b-form-input>
                    <div v-show="errors.has('email')" class="error">{{ errors.first('email') }}</div>
                </div>
                <div class="col-md-12 mt-1">
                    <label>{{$t('auth.password')}}</label>
                    <b-form-input v-model="edit.password" type="password" data-vv-name="password"
                                  v-validate="'min:4'" ref="password"
                                  :placeholder="$t('auth.password')"
                                  size="lg"
                    ></b-form-input>
                    <div v-show="errors.has('password')" class="error">{{ errors.first('password') }}</div>
                </div>
                <div class="col-md-12 mt-1">
                    <label>{{$t('auth.confirm_password')}}</label>
                    <b-form-input type="password" v-validate="'confirmed:password'"
                                  :placeholder="$t('auth.confirm_password')"
                                  size="lg"
                                  v-model="edit.repassword"
                                  autocomplete="nope"
                                  data-vv-name="password_confirm"></b-form-input>
                    <div v-show="errors.has('password_confirm')" class="error">{{ errors.first('password_confirm')
                        }}</div>
                </div>
                <div class="col-md-12 mt-1 mb-3">
                    <label>{{$t('auth.choose_sport')}}</label>
                    <multiselect v-model="sel.disciplines"
                                 :options="disciplines"
                                 :multiple="true"
                                 track-by="value"
                                 label="text"
                    ></multiselect>
                </div>
                <div class="col-md-12 mt-1">
                    <b-form-checkbox v-model="edit.check_comunicazioni"  :value="true">
                        {{$t('auth.testo_comunicazioni')}}
                    </b-form-checkbox>
                </div>
                <div class="col-md-12 mt-1">
                    <b-form-checkbox v-model="edit.check_terzi"  :value="true">
                        {{$t('auth.terzo_terzi')}}
                    </b-form-checkbox>
                </div>
            </b-form>
            <template class="d-flex align-items-center justify-content-between" v-slot:modal-footer="{ ok, cancel, hide }">
                <b-button variant="primary" @click="ok()">{{$t('auth.submit')}}</b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
    import BaseVue from "../views/BaseVue"
    import Multiselect from 'vue-multiselect'

    import { EventBus } from '../util/event-bus.js';

    export default {
        extends: BaseVue,
        name: 'Login',
        props: {
            as_text: {
                type: Boolean,
                default: false
            },
        },
        components: { Multiselect },
        async mounted() {
            this.data_max = this.$moment().format('DD-MM-YYYY')
            this.disableLogin = this.$store.getters.disableLogin
            EventBus.$on('open_login', () => {
                this.openLogin()
            })
        },
        data() {
            return {
                disableLogin:false,
                email: '',
                password: '',
                remember:false,
                in_login: false,
                in_register: false,
                in_edit: false,
                in_recovery: false,
                register: {
                    devicetag: 'web',
                    surname: '',
                    name: '',
                    sex: '',
                    birthdate: null,
                    email: '',
                    country: 'ITA',
                    region: '',
                    disciplines: '',
                    password: '',
                    repassword: '',
                    check_uso_portale: false,
                    check_comunicazioni: false,
                    check_terzi: false,
                },
                edit: {
                    email: '',
                    disciplines: '',
                    password: '',
                    repassword: '',
                    check_comunicazioni: false,
                    check_terzi: false,
                },
                opt: {
                    country: [],
                    region: [],
                    disciplines: []
                }, sel: {
                    disciplines: [],
                }, data_max: '30-12-2030'
            }
        },
        computed: {
            logged() {
                return this.$store.getters.logged
            }, country() {
                return this.optsFromTable(this.opt.country)
            }, region() {
                return this.optsFromTable(this.opt.region)
            }, disciplines() {
                return this.optsFromTable(this.opt.disciplines)
            },reg_title() {
                if (this.in_login) return this.$t('auth.title_login')
                if (this.in_recovery) return  this.$t('auth.title_recover')
                if (this.in_edit) return  this.$t('auth.title_edit')
                else return  this.$t('auth.title_register')
            }, user_name() {
                return this.$store.getters.user_name
            }, user_surname() {
                return this.$store.getters.user_surname
            }
        },
        methods: {
            doAction(evt) {
                if (this.in_register)
                    this.doRegister(evt)
                else if (this.in_edit)
                    this.doEdit(evt)
            },
            async doRegister(evt) {
                evt.preventDefault()

                if (this.register.country !== 'ITA') this.register.region = ''
                this.register.disciplines = []
                for (let i = 0; i < this.sel.disciplines.length; i++)
                    this.register.disciplines.push(this.sel.disciplines[i].value)


                this.register.disciplines = this.register.disciplines.join(',')

                // Verifico se tutti i campi sono stati correttamente valorizzati
                if (this.register.surname.length < 2) return this.error('surname')
                if (this.register.name.length < 2) return this.error('name')
                if (this.register.sex.length !== 1) return this.error('sex')
                if (this.register.birthdate.length !== 10) return this.error('birthdate')
                if (this.register.email.length < 4) return this.error('email')
                if (this.register.password.length < 3) return this.error('password')
                if (this.register.repassword != this.register.password) return this.error('repassword')
                if (!this.register.check_uso_portale) return this.error('check_portale')

                this.$store.commit('loading', true)
                let url = this.$store.getters.base_url + '/'+this.$store.getters.locale+'/adduser'
                let data = await this.$http.post(url, this.register)
                this.$store.commit('loading', false)

                let info = data.data
                if (info.Status.Code !== 100)
                    return this.error(info.Status.Description, false)

                this.$store.commit('user',info.LoggedUsers)
                if(info.LoggedUsers.Gender === 'M') {
                        this.$notify({type: 'alert-info', text: this.$t('login.welcome.man',{name:this.register.name,surname:this.register.surname})})
                    } else {
                       this.$notify({type: 'alert-info', text: this.$t('login.welcome.women',{name:this.register.name,surname:this.register.surname})})
                    }


                this.register.surname = ''
                this.register.name = ''
                this.register.sex = ''
                this.register.birthdate = ''
                this.register.email = ''
                this.register.password = ''
                this.$refs.mod_login.hide()

                EventBus.$emit('login', true);

            },async doEdit(evt) {
                evt.preventDefault()

                if (this.register.country !== 'ITA') this.register.region = ''
                this.edit.disciplines = []
                for (let i = 0; i < this.sel.disciplines.length; i++)
                    this.edit.disciplines.push(this.sel.disciplines[i].value)
                this.edit.disciplines = this.edit.disciplines.join(',')



                // Verifico se tutti i campi sono stati correttamente valorizzati
                if (this.edit.email.length < 4) return this.error('email')
                if (this.edit.password.length > 0)
                {
                    if (this.edit.password.length < 3)
                        return this.error('password')
                    if (this.edit.repassword != this.edit.password)
                        return  this.error('repassword')
                }


                this.$store.commit('loading', true)
                let url = this.$store.getters.url + 'edituser'
                let data = await this.$http.post(url, this.edit)
                this.$store.commit('loading', false)

                let info = data.data
                if (info.Status.Code !== 0)
                    return this.error(info.Status.Description, false)

                this.$notify({type: 'alert-info', text: this.$t('auth.edit_done')})
                this.$refs.mod_login.hide()
            }, async getRegisterData() {
                setTimeout(() => {
                    if ( document.getElementById('login_email'))
                        document.getElementById('login_email').focus()
                },100)


                if (this.opt.country.length > 0) return true
                let data = await this.get([
                    'table/country',
                    'table/region',
                    'table/discipline'
                ])

                this.opt.country = data[0].GenericTables
                this.opt.region = data[1].GenericTables
                this.opt.disciplines = data[2].GenericTables
            }, async login(evt) {
                evt.preventDefault()
                this.$store.commit('loading', true)

                let url =  this.$store.getters.base_url+'/login/' + this.$store.getters.locale + '/' + this.email + '/web'
                let ret = await this.$http.post(url, {password:this.password})
                let info = ret.data
                this.$store.commit('loading', false)

                if (info.Status.Code === 100) {
                    info.LoggedUsers.remember = this.remember
                    this.$store.commit('user',info.LoggedUsers)
                    if(info.LoggedUsers.Gender === 'M') {
                        this.$notify({type: 'alert-info', text: this.$t('login.welcome.man',{name:info.LoggedUsers.UserName,surname:info.LoggedUsers.UserSurname})})
                    } else {
                       this.$notify({type: 'alert-info', text: this.$t('login.welcome.women',{name:info.LoggedUsers.UserName,surname:info.LoggedUsers.UserSurname})})
                    }

                    this.email = ''
                    this.password = ''
                    this.$refs.mod_login.hide()
                    EventBus.$emit('login', true);
                }
                else if (info.Status.Code === 101) {
                    this.$notify({type: 'alert-warning', text: this.$t('login.wrong_username')})
                }
                else {
                    this.$notify({type: 'alert-warning', text: info.Status.Description})
                }

            }, async recover(evt) {
                evt.preventDefault()
                this.$store.commit('loading', true)
                let base = this.$store.getters.base_url
                let url = '/'+ this.$store.getters.locale+'/resetpassword/'+ this.email
                let info = await this.get(url,true,base)
                this.$store.commit('loading', false)
                if (info.Status.Code === 100) {
                    this.$notify({type: 'alert-info', text: info.Info})
                }
                else {
                    this.$notify({type: 'alert-warning', text: info.Status.Description})
                }

            }, async logout() {
                this.$store.commit('loading', true)
                let base = this.$store.getters.base_url
                let url ='/logout/' + this.$store.getters.locale + '/' + this.$store.getters.token
                await this.get(url,true,base)

                this.$store.commit('user', null)
                this.$store.commit('loading', false)
                EventBus.$emit('logout', true);
            }, optsFromTable(values) {
                if (values.length <= 0) return [{value: -1, text: ' - '}]
                let opts = []
                for (let i = 0; i < values.length; i++)
                    opts.push({value: values[i].Code, text: values[i].Description})
                return opts
            }, error(field, isKey) {
                if (typeof isKey === 'undefined') isKey = true

                if (isKey)
                    this.$notify({type: 'alert-warning', text: this.$t('register.error.' + field)})
                else
                    this.$notify({type: 'alert-warning', text: field})
                return false
            }, data_format(value) {
                if (value === null) return ''

                value = this._applyAt(value, 2, '-');
                value = this._applyAt(value, 5, '-');
                return value;
            }, _applyAt(value, pos, divider) {
                let first = '';
                let last = '';

                if (value.length > pos) {
                    if (value[pos] !== divider) {
                        if (this.isNumeric(value[pos])) {
                            first = value.substr(0, pos);
                            last = value.substr(pos);
                            value = first + divider + last;
                        } else {
                            first = value.substr(0, pos);
                            last = value.substr(pos + 1);
                            value = first + divider + last;
                        }
                    }
                }
                return value;
            },isNumeric(s) {
                return !isNaN(s - parseFloat(s));
            },openLogin()
            {
                this.in_login = true
                this.in_register = false
                this.in_edit = false
                this.in_recovery = false
                this.$refs.mod_login.show()
            }, openRecover()
            {
                this.in_login = false
                this.in_register = false
                this.in_edit = false
                this.in_recovery = true
            }, openRegister()
            {
                this.in_login = false
                this.in_register = true
                this.in_edit = false
                this.in_recovery = false
            }, async openEdit() {
                await this.getRegisterData()
                this.in_login = false
                this.in_register = false
                this.in_edit = true
                this.in_recovery = false


                let data = await this.get('edituser')
                let user = data.User
                // Estraggo le info per l'edit

                this.$refs.mod_login.show()
                this.edit.name = user.name
                this.edit.surname = user.surname
                this.edit.sex = user.sex
                let birth = user.birthdate.split('-')
                this.edit.birthdate = birth[2]+'-'+birth[1]+'-'+birth[0]
                this.edit.email = user.email
                this.edit.country = user.country
                this.edit.region = user.region
                this.edit.check_terzi = user.check_terzi
                this.edit.check_comunicazioni = user.check_comunicazioni
                this.edit.password = ''


                this.sel.disciplines = []
                for (let i = 0; i < user.disciplines.length; i++)
                    for (let j = 0; j < this.disciplines.length; j++)
                        if (this.disciplines[j].value == user.disciplines[i])
                            this.sel.disciplines.push(this.disciplines[j])
            }
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
